import { render, staticRenderFns } from "./ResetSubPassLogBody.vue?vue&type=template&id=2c929df4&"
import script from "./ResetSubPassLogBody.vue?vue&type=script&lang=ts&"
export * from "./ResetSubPassLogBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports